import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import { ASSET_PATTERN_COLOR, BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    name: FONT_FAMILY.name,

    // hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '50px',
    subHeading: '32px',
    body: '16px',
    name: '42px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    name: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-name': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_COLOR.primary,
    bgSecondary: BG_COLOR.secondary,
    bgTertiary: BG_COLOR.tertiary,
    bgAlternative: BG_COLOR.alternative,
    mainColorText: TEXT_COLOR.primary,
    secondaryColorText: TEXT_COLOR.secondary,
    tertiaryColorText: TEXT_COLOR.tertiary,
    alternativeColorText: TEXT_COLOR.alternative,
    assetPatternColor: ASSET_PATTERN_COLOR,
    transparent: 'transparent',
  },
};

export default extendTheme(theme);
